<template>
  <div v-loading="loading">
    <div class="c_page-title" style="margin-bottom: 20px">
      <div>包裹点货详情</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchData(true)"
        >刷新</el-button
      >
    </div>
    <div class="blockinfo">
      <el-row v-if="resData">
        <el-col :span="4">
          <el-row>
            <el-col :span="24">
              <div class="info-row">
                <span>包裹号:</span>
                <span>{{ resData.package_no }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div class="info-row">
                <span>包裹商品数量：</span>
                <span>{{ resData.goods_num }}</span>
              </div>
            </el-col>
          </el-row>
        </el-col>

        <el-col :span="4">
          <el-row>
            <el-col :span="24">
              <div class="info-row">
                <span>商家：</span>
                <span>{{ resData.supply_name }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div class="info-row">
                <span>市场：</span>
                <span>{{ resData.market_name }}</span>
              </div>
            </el-col>
          </el-row>
        </el-col>

        <el-col :span="4">
          <el-row>
            <el-col :span="24">
              <div class="info-row">
                <span>代采组：</span>
                <span>{{ resData.pgname }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div class="info-row">
                <span>代采员：</span>
                <span>{{ resData.pm_member_name }}</span>
              </div>
            </el-col>
          </el-row>
        </el-col>

        <el-col :span="4">
          <el-row>
            <el-col :span="24">
              <div class="info-row">
                <span>已提交批次单：</span>
                <span>{{ resData.pici_num }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div class="info-row">
                <span>收包图片：</span>
                <span>
                  <div
                    v-viewer
                    style="
                      width: 40px;
                      height: 40px;
                      overflow: hidden;
                      cursor: pointer;
                      display: inline-block;
                      vertical-align: text-top;
                    "
                  >
                    <img
                      v-for="(item, index) in resData.package_img"
                      :key="index"
                      :src="item"
                      style="width: 100%; height: 100%; vertical-align: middle"
                    />
                  </div>
                </span>
              </div>
            </el-col>
          </el-row>
        </el-col>

        <el-col :span="4">
          <el-row>
            <el-col :span="24">
              <div class="info-row">
                <span>异常处理人：</span>
                <span>{{ resData.yc_admin_name }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div class="info-row">
                <span>异常处理时间：</span>
                <span>{{ resData.create_time }}</span>
              </div>
            </el-col>
          </el-row>
        </el-col>

        <el-col :span="4">
          <el-row>
            <el-col :span="24">
              <div class="info-row">
                <span>包裹点货状态：</span>
                <span
                  v-if="resData.package_dabiao_status == 3"
                  style="color: blue"
                  >{{ resData.package_dabiao_status_txt }}</span
                >
                <span
                  v-if="resData.package_dabiao_status == 2"
                  style="color: red"
                  >{{ resData.package_dabiao_status_txt }}</span
                >
                <span v-if="resData.package_dabiao_status == 1">{{
                  resData.package_dabiao_status_txt
                }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div class="info-row">
                <span>异常原因：</span>
                <span>{{ resData.yc_remark }}</span>
              </div>
            </el-col>
          </el-row>
        </el-col>

        <el-col :span="24" style="margin-bottom: 20px">
          <el-col :span="4">
            <el-row>
              <div class="info-row">
                <span> 包裹状态：</span>
                <span>{{ resData.packge_status_text }}</span>
              </div>
            </el-row>
          </el-col>
          <el-col :span="4">
            <el-row>
              <div class="info-row">
                <span> 打标来源：</span>
                <span>{{ resData.db_source_text }}</span>
              </div>
            </el-row>
          </el-col>
          <el-col :span="4">
            <el-row>
              <div class="info-row">
                <span> 爆版发货单：</span>
                <span>{{ resData.invoice_no_text }}</span>
              </div>
            </el-row>
          </el-col>
          <el-col :span="4">
            <el-row>
              <div class="info-row">
                <span> 快递运单号：</span>
                <span>{{ resData.shipping_num }}</span>
              </div>
            </el-row>
          </el-col>
        </el-col>

        <el-col :span="24" style="margin-bottom: 20px">
          <el-col :span="4">
            <el-row>
              <div class="info-row">
                <span> 作废原因：</span>
                <span>{{ resData.waste_reason_text }}</span>
              </div>
            </el-row>
          </el-col>
        </el-col>

        <el-col :span="24">
          <el-col :span="4">
            <el-row>
              <div class="info-row" style="display: table">
                <div style="display: table-cell; width: 78px">关联包裹：</div>
                <div style="display: table-cell; word-break: break-all">
                  {{ resData.relation_packages }}
                </div>
              </div>
            </el-row>
          </el-col>
        </el-col>
      </el-row>
    </div>
    <div style="margin-bottom: 20px">
      <div class="card-title">
        <div>包裹点货汇总</div>
      </div>
      <el-table :data="resData.pici_data" border style="width: 100%">
        <el-table-column prop="goods_num" label="包裹商品数" align="center">
        </el-table-column>
        <el-table-column prop="pici_eff_num" label="有效点货" align="center">
        </el-table-column>
        <el-table-column prop="pici_inv_num" label="不良品" align="center">
        </el-table-column>
        <el-table-column
          prop="pici_no_data_num"
          label="无数据商品"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="diff_num" label="差异" align="center">
        </el-table-column>
        <el-table-column prop="note" label="操作" align="center" width="300px">
          <template slot-scope="scope">
            <el-button
              v-if="resData.package_dabiao_status == '2'"
              type="success"
              @click="dialogFormVisible = true"
              >处理</el-button
            >
            <el-button
              v-show="
                ['1', '2'].includes(resData.packge_status) &&
                !['3'].includes(resData.db_source)
              "
              type="danger"
              @click="showWasteDialog"
              >作废</el-button
            >
            <el-button
              v-show="['3', '4'].includes(resData.packge_status)"
              type="infor"
              @click="showRelationDialog"
              >关联包裹</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 50px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>包裹批次点货数据</div>
          <!--<el-button type="text" style="margin-left: auto;" :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" @click="toggleFilter">{{filterFold ? '展开筛选' : '收起筛选'}}</el-button>-->
          <el-select
            v-model="pici_arr"
            multiple
            placeholder="请选择批次号"
            style="margin-left: auto"
            @change="getPiciGoods"
          >
            <el-option
              v-for="item in resData.pici_arr_kv"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>

        <div class="sub_table" style="padding-top: 20px">
          <div class="card-title">
            <div>有效商品（{{ effGoods.total }}）</div>
            <el-form
              :inline="true"
              :model="filteredEffGoods"
              class="demo-form-inline"
              size="mini"
            >
              <el-form-item>
                <el-input
                  v-model.trim="filteredEffGoods.goods_name"
                  placeholder="商品名称"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-input
                  v-model.trim="filteredEffGoods.goods_no"
                  placeholder="商品货号"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-input
                  v-model.trim="filteredEffGoods.sku"
                  placeholder="sku"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="getEffGoods">查询</el-button>
              </el-form-item>
            </el-form>
          </div>
          <el-table
            :data="effGoods.data"
            border
            style="width: 100%"
            height="400"
          >
            <el-table-column prop="dbrid" label="打标编号" align="center">
            </el-table-column>
            <!-- <el-table-column prop="supply_name" label="商家" align="center">
            </el-table-column> -->
            <el-table-column prop="pgname" label="代采组" align="center">
            </el-table-column>
            <el-table-column prop="goods_img" label="商品图片" align="center">
              <template slot-scope="scope">
                <div
                  v-viewer
                  style="
                    width: 40px;
                    height: 40px;
                    overflow: hidden;
                    cursor: pointer;
                    display: inline-block;
                  "
                >
                  <img
                    v-for="(item, index) in scope.row.goods_img"
                    :key="index"
                    :src="item"
                    style="width: 100%; height: 100%"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="goods_name" label="商品名称" align="center">
            </el-table-column>
            <el-table-column prop="goods_no" label="商品货号" align="center">
            </el-table-column>
            <el-table-column prop="co_val" label="颜色" align="center">
            </el-table-column>
            <el-table-column prop="si_val" label="尺码" align="center">
            </el-table-column>
            <el-table-column prop="sku" label="sku" align="center">
            </el-table-column>
            <el-table-column prop="market_price" label="代采价" align="center">
            </el-table-column>
            <el-table-column prop="dbid" label="打标ID" align="center">
            </el-table-column>
            <el-table-column prop="type_text" label="类型" align="center">
            </el-table-column>
            <el-table-column prop="admin_name" label="打标人" align="center">
            </el-table-column>
            <el-table-column prop="create_time" label="打标时间" align="center">
            </el-table-column>
            <el-table-column prop="pici_no" label="批次号" align="center">
            </el-table-column>
            <el-table-column prop="pici_type" label="批次类型" align="center">
            </el-table-column>
            <el-table-column
              prop="pici_create_name"
              label="批次创建人"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="pici_create_time"
              label="批次创建时间"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="commit_time" label="提交时间" align="center">
            </el-table-column>
          </el-table>
          <div style="text-align: right; padding: 25px">
            <el-pagination
              :current-page.sync="effGoods.current_page"
              background
              layout="total, prev, pager, next, jumper "
              :total="effGoods.total"
              :page-size="10"
              @current-change="getEffGoods"
            >
            </el-pagination>
          </div>
        </div>
        <div class="sub_table">
          <div class="card-title">
            <div>不良品商品（{{ invalidGoods.total }}）</div>
            <el-form
              :inline="true"
              :model="filteredInvalidGoods"
              class="demo-form-inline"
              size="mini"
            >
              <el-form-item>
                <el-input
                  v-model.trim="filteredInvalidGoods.goods_name"
                  placeholder="商品名称"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-input
                  v-model.trim="filteredInvalidGoods.goods_no"
                  placeholder="商品货号"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-input
                  v-model.trim="filteredInvalidGoods.sku"
                  placeholder="sku"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="getInvalidGoods"
                  >查询</el-button
                >
              </el-form-item>
            </el-form>
          </div>
          <!-- <el-table :data="invalidGoods.data" border style="width: 100%" height="400" v-if="invalidGoods && invalidGoods.data.length > 0"> -->
          <el-table
            :data="invalidGoods.data"
            border
            style="width: 100%"
            height="400"
          >
            <el-table-column prop="dbrid" label="打标编号" align="center">
            </el-table-column>
            <!-- <el-table-column prop="supply_name" label="商家" align="center">
            </el-table-column> -->
            <el-table-column prop="pgname" label="代采组" align="center">
            </el-table-column>
            <el-table-column prop="goods_img" label="商品图片" align="center">
              <template slot-scope="scope">
                <div
                  v-viewer
                  style="
                    width: 40px;
                    height: 40px;
                    overflow: hidden;
                    cursor: pointer;
                    display: inline-block;
                  "
                >
                  <img
                    v-for="(item, index) in scope.row.goods_img"
                    :key="index"
                    :src="item"
                    style="width: 100%; height: 100%"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="goods_name" label="商品名称" align="center">
            </el-table-column>
            <el-table-column prop="goods_no" label="商品货号" align="center">
            </el-table-column>
            <el-table-column prop="co_val" label="颜色" align="center">
            </el-table-column>
            <el-table-column prop="si_val" label="尺码" align="center">
            </el-table-column>
            <el-table-column prop="sku" label="sku" align="center">
            </el-table-column>
            <el-table-column prop="market_price" label="代采价" align="center">
            </el-table-column>
            <el-table-column prop="dbid" label="打标ID" align="center">
            </el-table-column>
            <el-table-column prop="type_text" label="类型" align="center">
            </el-table-column>
            <el-table-column prop="admin_name" label="打标人" align="center">
            </el-table-column>
            <el-table-column prop="create_time" label="打标时间" align="center">
            </el-table-column>
            <el-table-column prop="pici_no" label="批次号" align="center">
            </el-table-column>
            <el-table-column prop="pici_type" label="批次类型" align="center">
            </el-table-column>
            <el-table-column
              prop="pici_create_name"
              label="批次创建人"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="pici_create_time"
              label="批次创建时间"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="commit_time" label="提交时间" align="center">
            </el-table-column>
          </el-table>
          <div style="text-align: right; padding: 25px">
            <el-pagination
              :current-page.sync="invalidGoods.current_page"
              background
              layout="total, prev, pager, next, jumper "
              :total="invalidGoods.total"
              :page-size="10"
              @current-change="getInvalidGoods"
            >
            </el-pagination>
          </div>
        </div>

        <div class="sub_table">
          <div class="card-title">
            <div>无数据商品（{{ noDataGoods.total }}）</div>
          </div>
          <!-- <el-table :data="invalidGoods.data" border style="width: 100%" height="400" v-if="invalidGoods && invalidGoods.data.length > 0"> -->
          <el-table
            :data="noDataGoods.data"
            border
            style="width: 100%"
            height="400"
          >
            <el-table-column prop="ndgid" label="无数据标id" align="center">
            </el-table-column>
            <el-table-column prop="img" label="商品图片" align="center">
              <template slot-scope="scope">
                <div
                  v-viewer
                  style="
                    width: 40px;
                    height: 40px;
                    overflow: hidden;
                    cursor: pointer;
                    display: inline-block;
                  "
                >
                  <img
                    v-for="(item, index) in scope.row.img"
                    :key="index"
                    :src="item"
                    style="width: 100%; height: 100%"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="co_val" label="颜色" align="center">
            </el-table-column>
            <el-table-column prop="si_val" label="尺码" align="center">
            </el-table-column>
            <el-table-column prop="pgname" label="代采组" align="center">
            </el-table-column>
            <el-table-column prop="dbid" label="打标id" align="center">
            </el-table-column>
            <el-table-column prop="admin_name" label="创建人" align="center">
            </el-table-column>
            <el-table-column prop="note" label="备注" align="center">
            </el-table-column>
            <el-table-column prop="create_time" label="创建时间" align="center">
            </el-table-column>
            <el-table-column prop="pici_no" label="批次号" align="center">
            </el-table-column>
            <el-table-column prop="pici_type" label="批次类型" align="center">
            </el-table-column>
            <el-table-column
              prop="pici_create_name"
              label="批次创建人"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="pici_create_time"
              label="批次创建时间"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="commit_time" label="提交时间" align="center">
            </el-table-column>
          </el-table>
          <div style="text-align: right; padding: 25px">
            <el-pagination
              :current-page.sync="noDataGoods.current_page"
              background
              layout="total, prev, pager, next, jumper "
              :total="noDataGoods.total"
              :page-size="10"
              @current-change="getNoDataGoods"
            >
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>

    <el-dialog
      title="处理异常"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      center
      width="30%"
    >
      <el-form :model="yc_form">
        <el-form-item label="异常类型:">
          <template>
            <el-radio v-model="yc_form.yc_type" label="1"
              >商家报错包裹数量</el-radio
            >
            <el-radio v-model="yc_form.yc_type" label="2"
              >收包人员录错包裹数量</el-radio
            >
          </template>
        </el-form-item>
        <el-form-item label="异常原因备注:">
          <el-input v-model="yc_form.yc_remark" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="update">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 作废弹窗 -->
    <el-dialog
      title="作废原因"
      :visible.sync="dialog_setting.waste.show"
      :close-on-click-modal="false"
      center
      width="20%"
    >
      <div
        v-for="(item, key) in resData.waste_reason_map"
        :key="key"
        style="margin-bottom: 20px"
      >
        <el-radio v-model="dialog_setting.waste.waste_reason" :label="key">{{
          item
        }}</el-radio>
      </div>
      <div slot="footer" style="text-align: right">
        <el-button @click="dialog_setting.waste.show = false">取 消</el-button>
        <el-button type="primary" @click="confirmWaste">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 包裹关联弹窗 -->
    <el-dialog
      title="包裹关联"
      :visible.sync="dialog_setting.relation.show"
      :close-on-click-modal="false"
      center
      width="30%"
    >
      <el-input
        ref="relationPackageNosRef"
        v-model="dialog_setting.relation.package_nos"
        type="textarea"
        placeholder="请输入需关联的包裹号, 如有多个请用换行隔开"
        :autosize="{ minRows: 4, maxRows: 10 }"
      ></el-input>
      <div slot="footer" style="text-align: right">
        <el-button @click="dialog_setting.relation.show = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="confirmRelation">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      resData: {
        chayi_img: [],
        pici_img: [],
        pici_goods_data: [],
      },
      loading: false,
      files: [],
      dialogTableVisible: false,
      dialogGoods: null,
      editable: false,
      index: null,
      paytime: "",
      initData: "",
      effGoods: {
        data: [],
        total: 0,
        current_page: 1,
      }, // 有效商品
      invalidGoods: {
        data: [],
        total: 0,
        current_page: 1,
      }, // 无效商品
      noDataGoods: {
        data: [],
        total: 0,
        current_page: 1,
      }, // 无数据商品
      filterFold: false, // 日志折叠判断字段
      filteredEffGoods: {}, // 有效商品的筛选条件
      filteredInvalidGoods: {}, // 无效商品的筛选条件
      goodsNum: "", // 货品总数量
      parcelNum: "", // 包裹数量
      remarks: "", // 备注
      chayiRemarks: "", // 差异备注
      chayiImg: [], // 差异图片
      piciImg: [], // 批次图片
      pici_ids: "",
      pici_arr: [],
      dialogFormVisible: false,
      yc_form: {
        yc_type: 1,
      },
      dialog_setting: {
        waste: {
          show: false,
          waste_reason: 0,
        },
        relation: {
          show: false,
          package_nos: "", // 输入的包裹号
        },
      },
    };
  },
  computed: {
    // filteredFiles() {
    //   let arr = [];
    //   this.files.forEach(v => {
    //     arr.push(v.response.data.files[0]);
    //   });
    //   return arr;
    // },
    // chayi_img() {
    //   let arr = [];
    //   let str = "";
    //   this.chayiImg.forEach(v => {
    //     arr.push(v.response.data.files[0]);
    //   });
    //   str = arr.join(",");
    //   return str;
    // },
    // pici_img() {
    //   let arr = [];
    //   let str = "";
    //   this.piciImg.forEach(v => {
    //     arr.push(v.response.data.files[0]);
    //   });
    //   str = arr.join(",");
    //   return str;
    // }
  },
  methods: {
    getEffGoods() {
      const url = "/erp/Supply/getDaBiao";
      this.filteredEffGoods.is_eff = 1;
      this.filteredEffGoods.pici_nos = this.pici_arr;
      this.filteredEffGoods.page = this.effGoods.current_page;
      this.$http.post(url, this.filteredEffGoods).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.effGoods = res.data.data;
        }
      });
    },
    getInvalidGoods() {
      const url = "/erp/Supply/getDaBiao";
      this.filteredInvalidGoods.is_eff = 0;
      this.filteredInvalidGoods.pici_nos = this.pici_arr;
      this.filteredInvalidGoods.page = this.invalidGoods.current_page;
      this.$http.post(url, this.filteredInvalidGoods).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.invalidGoods = res.data.data;
        }
      });
    },
    getNoDataGoods() {
      const url = "/erp/Supply/getDaBiao";
      this.$http
        .post(url, {
          is_eff: 2,
          pici_nos: this.pici_arr,
          page: this.noDataGoods.current_page,
        })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.noDataGoods = res.data.data;
          }
        });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    update() {
      if (!this.resData.package_record_id) {
        this.$message({ type: "info", message: "收包记录id不存在" });
        return false;
      }
      const url = "/erp/Supply/handlePackageYc";
      this.yc_form.package_record_id = this.resData.package_record_id;
      this.loading = true;
      this.$http.post(url, this.yc_form).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.$notify({
            title: "操作成功",
            message: "",
            type: "success",
          });
          this.dialogFormVisible = false;
          setTimeout(() => {
            this.fetchData();
          }, 300);
        }
        this.loading = false;
      });
    },

    fetchData(val) {
      if (val) {
        this.loading = true;
      }
      const url = "/erp/Supply/packageDetail";
      const args = {
        package_record_id: this.$route.params.id,
      };
      this.$http.post(url, args).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          this.pici_ids = res.data.data.pici_ids;
          console.log(this.pici_ids);
          console.log(this.resData);

          if (this.resData.pici_ids) {
            this.$http
              .post("/erp/Supply/getDaBiao", {
                is_eff: 1,
                pici_nos: this.resData.pici_arr,
              })
              .then((res) => {
                if (res.data.code !== 200) {
                  this.$message.error(res.data.msg);
                } else {
                  this.effGoods = res.data.data;
                }
              });
            this.$http
              .post("/erp/Supply/getDaBiao", {
                is_eff: 0,
                pici_nos: this.resData.pici_arr,
              })
              .then((res) => {
                if (res.data.code !== 200) {
                  this.$message.error(res.data.msg);
                } else {
                  this.invalidGoods = res.data.data;
                }
              });
            this.$http
              .post("/erp/Supply/getDaBiao", {
                is_eff: 2,
                pici_nos: this.resData.pici_arr,
              })
              .then((res) => {
                if (res.data.code !== 200) {
                  this.$message.error(res.data.msg);
                } else {
                  this.noDataGoods = res.data.data;
                }
              });
          }
        }
        this.loading = false;
      });
    },
    // 切换页码
    handleNoDataPage(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    getPiciGoods() {
      console.log(this.pici_arr);
      if (this.pici_arr.length != 0) {
        this.getEffGoods();
        this.getInvalidGoods();
        this.getNoDataGoods();
      }
    },

    // 显示作废弹窗
    showWasteDialog() {
      this.$set(this.dialog_setting.waste, "show", true);
      this.$set(this.dialog_setting.waste, "waste_reason", 0);
    },
    // 确定作废
    confirmWaste() {
      if (this.dialog_setting.waste.waste_reason == 0) {
        return this.$message.e("请选择作废原因");
      }
      const param = {
        package_record_id: this.$route.params.id,
        waste_reason: this.dialog_setting.waste.waste_reason,
      };
      this.$http.post("/erp/Supply/wasteSupplyPackage", param).then((rs) => {
        if (rs.data.code != 200) {
          return this.$message.e(rs.data.msg);
        }
        this.$set(this.dialog_setting.waste, "show", false);
        // 第一个作废原因要显示关联弹窗
        let { msg } = rs.data;
        if (param.waste_reason == 1) {
          msg += ", 请输入关联包裹";
          this.showRelationDialog();
        }
        this.$message.success(msg);
        // 更新一下数据
        this.fetchData();
      });
    },
    // 显示关联弹窗
    showRelationDialog() {
      this.$set(this.dialog_setting.relation, "package_nos", "");
      this.$set(this.dialog_setting.relation, "show", true);
      this.$nextTick((_) => {
        this.$refs.relationPackageNosRef.focus();
      });
    },

    // 确定关联
    confirmRelation() {
      if (this.dialog_setting.relation.package_nos.length == 0) {
        return this.$message.e("请输入包裹号");
      }
      this.$http
        .post("/erp/Supply/relationSupplyPackage", {
          package_record_id: this.$route.params.id,
          package_nos: this.dialog_setting.relation.package_nos,
        })
        .then((rs) => {
          if (rs.data.code != 200) {
            return this.$message.e(rs.data.msg);
          }
          this.$set(this.dialog_setting.relation, "show", false);
          this.$message.success(rs.data.msg);
          // 更新一下数据
          this.fetchData();
        });
    },
  },
};
</script>

<style scoped>
.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}

.card-title {
  background: #f3f3f3;
  height: 50px;
  line-height: 30px;
  padding: 0 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.card-title .el-form-item {
  margin-bottom: 0;
}

.highlight {
  color: red;
}

.blockinfo {
  /* border-top: 1px solid #ddd; */
  border-bottom: 1px solid #ddd;
  padding: 0 10px 20px;
  margin-bottom: 20px;
}

.info-row {
  color: #666;
  font-size: 14px;
}

.info-row > span:first-child {
  color: #333;
}

.order-log {
  margin-bottom: 20px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}

.sub_table {
  padding: 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/supply/PackageDetail.vue